module.exports = __webpack_public_path__ + "static/media/MaintenanceBG.41c21679.jpg";